<route>
{
  "meta": {
    "requiresAuth": true
  }
}
</route>

<template>
  <div>
    <h1>Welcome, {{user.attributes.name}}</h1>
    <div>{{user.attributes.email}}</div>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify';

export default {
  name: 'Profile',
  data() {
    return {
      user: { attributes: {} },
    };
  },
  beforeCreate() {
    Auth.currentAuthenticatedUser()
      .then((user) => {
        this.user = user;
      })
      .catch(() => console.log('not signed in...'));
  },
};
</script>
